export default {
  apiUrl: 'http://51.79.70.136:4600/',
  peeringHubApiUrl: 'https://api.peeringhub.mobi/'
}
